import { CardholderBenefitsModel } from "./types";

export const defaultsCardholderAdditionalBenefits: CardholderBenefitsModel = {
  customerNumber: null,
  isCardholderLoyaltyParticipant: null,
};
